import Vue from 'vue'
import store from '../store'

export default [
  {
    path: '/visitas',
    name: 'visitas-index',
    beforeEnter: async (to, from, next) => {
      await store.dispatch('getPaginateVisitas')
      next()
    },
    meta: {
      title: 'Visitas',
      paginateMethod: 'getPaginateVisitas',
      paginateAttr: 'paginateVisitas',
      twoLines: true,
      subtitleAttr: item => Vue.options.filters.date(item['data_visita']),
      titleAttr: item => item['cliente'],
      routeToCreate: 'visitas-create',
      routeToEdit: 'visitas-details',
      emptyList: 'Nenhuma visita foi cadastrada ainda.',
      avatarIcon: 'transfer_within_a_station',
      pageAttr: 'visitaPage',
      pageCommit: 'setVisitaPage',
      filterAttr: 'visitaFilter',
      filterCommit: 'setVisitaFilter',
      requireAuth: true
    },
    component: function () {
      return import(/* webpackChunkName: "routes" */ '@/views/paginate')
    }
  },
  {
    path: '/visitas/novo',
    name: 'visitas-create',
    beforeEnter: async (to, from, next) => {
      await store.dispatch('getTecnicos')
      await store.dispatch('getClientes')
      await store.commit('setVisita', {
        proporcao: '1'
      })
      next()
    },
    meta: {
      title: 'Nova visita',
      requireAuth: true
    },
    component: function () {
      return import(/* webpackChunkName: "routes" */ '@/views/visita/id')
    }
  },
  {
    path: '/visitas/:id',
    name: 'visitas-update',
    props: true,
    beforeEnter: async (to, from, next) => {
      await store.dispatch('getClientes')
      await store.dispatch('getTecnicos')
      await store.dispatch('getVisita', {
        id: Number(to.params.id)
      })
      next()
    },
    meta: {
      title: 'Atualizar visita',
      requireAuth: true
    },
    component: function () {
      return import(/* webpackChunkName: "routes" */ '@/views/visita/id')
    }
  },
  {
    path: '/visitas/:id/detalhes',
    name: 'visitas-details',
    props: true,
    beforeEnter: async (to, from, next) => {
      await store.dispatch('getVisita', {
        id: Number(to.params.id)
      })
      next()
    },
    meta: {
      title: 'Detalhes da visita',
      requireAuth: true
    },
    component: function () {
      return import(/* webpackChunkName: "routes" */ '@/views/visita/detalhe')
    }
  }
]
